module.exports = __webpack_public_path__ + "img/MAP.793ab4ef.png";